import { useDispatch } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { loadAllDimensions } from "store/actions/commonActions";

function useUpdateStoreDimensions() {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const updateStoreDimensions = () => {
    dispatch(loadAllDimensions());
  };

  return { updateStoreDimensions };
}

export default useUpdateStoreDimensions;
